// TODO Add non-breaking space before %, check that it passes tests
export function percentFormat(num, decimals = 2) {
	if (!num) return '0 %';
	const order = Math.pow(10, decimals);
	return (Math.floor(num * order) / order).toLocaleString('cs-CZ', {
		maximumFractionDigits: decimals
	}) +' %';
}
